import React from 'react';
import Link from '@material-ui/core/Link';
import Container from '@material-ui/core/Container';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';

class RegisterComplete extends React.Component  {

    render() {

        return (
            <Container component="main" maxWidth="xs">
                <div className={this.props.classes.paper}>
                    <Avatar className={this.props.classes.avatar}>
                        <CheckCircleOutlinedIcon/>
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Регистрация завершена
                    </Typography>
                    <br/>
                    <p>Вам на почту было выслано сообщение для подтверждения регистрации на сайте <Link href="https://www.alaber.ru">www.alaber.ru</Link>.</p>
                    <p>Пожалуйста, проверьте почту и подтвердите регистрацию.</p>
                    <p>После подтверждения, Вы сможете войти в личный кабинет.</p>
                    <p>Пожалуйста, не пытайтесь выполнять вход на сайт <Link href="https://www.alaber.ru">www.alaber.ru.</Link> до того как Вы подтвердите регистрацию через свою почту. Это может привести к временной блокировке Вашей учетной записи.</p>
                    <br />
                    <Link href="./" variant="body2">
                        Вход в портал
                    </Link>
                </div>
            </Container>
        )

    }

}

export default RegisterComplete;